import React, { useState } from 'react';
import Axios from 'axios';
import { servicios_grupogack_catalogo, cambios_no_guardados } from '../../../../../../Constants/Constants';
import { headersAuth } from '../../../../../../Services/AuthService';
import ModalService from '../../../ModalService/ModalService';
import AlertForm from '../../../../../../Services/AlertForm';
import FormNiveles from './FormNiveles';

const ModalEditNivel = ({ openEdit, setOpenEdit, elementSelect, editar, errorTable, nombreModulo }) => {

    const [error, setError] = useState(null);

    const cerrarModal = () => {
        setOpenEdit(false);
        setError(null);
    }

    const actualizarNivel = (nivel, nivelId) => {
        const info = { nivlaboralClave: nivel.nivelCve, status: nivel.nivelStatus };
        Axios.put(`${servicios_grupogack_catalogo}/nvlaboral/${elementSelect.id}`, info, headersAuth())
        .then(res => {
            switch(res.data.status) {
                case 200:
                    editar({ id: res.data.dataResponse.id, nivlaboralClave: res.data.dataResponse.nivlaboralClave, statusNom: res.data.dataResponse.status.statusNom });
                    setOpenEdit(false);
                    break;
                case 400:
                case 404:
                    setError(<AlertForm message={res.data.msg} />);
                    break;

                default:
                    errorTable(cambios_no_guardados);
                    break;

            }
        })
        .catch(error => errorTable(cambios_no_guardados));
    }

    return (
        <ModalService title="Actualizar Nivel" parentNode={nombreModulo}
            isOpen={ openEdit } onClose={ () => cerrarModal() } >
            <div className="row">
                <div className="col-12">
                    <FormNiveles
                        setError={setError}
                        error={error}
                        elementSelect={elementSelect}
                        actualizarNivel={actualizarNivel}
                    />
                </div>
            </div>
        </ModalService>
    );
}

export default ModalEditNivel;